import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from '../../../helpers';
import { cn } from '../../../lib/utils';

interface MobileMenuListProps {
  items: NavItem[];
  onClose: () => void;
}

const FOCUS_RING =
  'focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-[-2px]';

const MobileMenuList = ({ items, onClose }: MobileMenuListProps) => {
  const [openKey, setOpenKey] = useState<string | null>(null);

  const toggle = (key: string) => setOpenKey(prev => (prev === key ? null : key));

  const handleItemClick = (action: () => void) => {
    onClose();
    action();
  };

  return (
    <ul className="overflow-y-auto h-[calc(100vh-4rem)]">
      {items.map(item =>
        item.type === 'link' ? (
          <li key={item.label} className={item.isCta ? 'px-8 py-4' : undefined}>
            <Link
              to={item.to}
              onClick={onClose}
              className={cn(
                item.isCta
                  ? 'block w-full text-center rounded-md bg-secondary py-3 text-lg font-bold text-secondary-foreground'
                  : 'block w-full px-8 py-4 text-xl font-extrabold',
                FOCUS_RING,
              )}
            >
              {item.label}
            </Link>
          </li>
        ) : (
          <li key={item.label}>
            <button
              type="button"
              className={cn(
                'flex items-center justify-between w-full px-8 py-4 text-xl font-extrabold transition-colors',
                openKey === item.label && 'bg-[#0c1c33] text-secondary',
                FOCUS_RING,
              )}
              onClick={() => toggle(item.label)}
              aria-expanded={openKey === item.label}
            >
              {item.label}
              <ChevronRight
                size={24}
                className={cn(
                  'transition-transform duration-300',
                  openKey === item.label && 'rotate-90',
                )}
              />
            </button>
            {openKey === item.label && (
              <ul className="px-8 pb-8">
                {item.options.map(opt => (
                  <li key={opt.label}>
                    <button
                      type="button"
                      className={cn(
                        'block w-full text-left py-1 text-xl font-semibold capitalize leading-8 after:block after:border-b after:border-white/20 after:w-[30%] after:mt-3 after:mb-3',
                        FOCUS_RING,
                      )}
                      onClick={() => handleItemClick(opt.action)}
                    >
                      {opt.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ),
      )}
    </ul>
  );
};

export default MobileMenuList;
